export default "__VITE_ASSET__Dz$xBTWu__"